import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useExternalData } from '../../contexts/external-data-context';
import { useFormFields } from '../../contexts/form-fields-context';
import { useForm } from '../../../../contexts/form-context';
import { useSubmitButton } from '../../../../fields/submit-button/submit-button/use-submit-button';
import { useFieldActions } from '../../../../contexts/field-actions-context';
export const SubmitButtonField = _ref => {
  let {
    field,
    FieldLayout
  } = _ref;
  const {
    submitText,
    nextText,
    previousText,
    text
  } = field.properties;
  const componentsById = useFormFields();
  const externalData = useExternalData();
  const form = useForm();
  const {
    actions
  } = useFieldActions();
  const {
    handleSubmitClick,
    isDisabled,
    isInProgress,
    showPreviousButton,
    showNextButton,
    showSubmitButton,
    hasSteps
  } = useSubmitButton({
    form,
    id: field.id
  });
  const submitButtonText = submitText || text || '';
  const previousButtonText = previousText || '';
  const nextButtonText = nextText || '';
  const FieldComponent = componentsById[field.fieldType];
  if (!FieldComponent) {
    return null;
  }
  return /*#__PURE__*/React.createElement(FieldComponent, _extends({}, field.properties, {
    id: field.id,
    externalData: externalData,
    fieldType: field.fieldType,
    FieldLayout: FieldLayout,
    hasSteps: hasSteps,
    isDisabled: isDisabled,
    isInProgress: isInProgress,
    showPreviousButton: showPreviousButton,
    showNextButton: showNextButton,
    showSubmitButton: showSubmitButton,
    submitText: submitButtonText,
    previousText: previousButtonText,
    nextText: nextButtonText,
    onSubmitClick: handleSubmitClick,
    onPreviousClick: () => actions == null ? void 0 : actions.setPreviousStep(),
    onNextClick: () => actions == null ? void 0 : actions.setNextStep()
  }));
};
//# sourceMappingURL=submit-button-field.js.map